@defer (on immediate) {
  <div
    class="global-hero__container position-relative mx-auto"
    [style.backgroundImage]="backgroundImgPath"
    [style.backgroundPosition]="backgroundImgPosition"
  >
    @if (heroData.sillHouetteImage) {
      <div class="photo position-absolute z-1" #sillhouette>
        <picture [data]="sillhouetteData"></picture>
      </div>
    }
    <div
      class="global-hero__content position-relative d-flex flex-column flex-md-row justify-content-md-end align-items-center"
    >
      <div class="photo-frame position-relative">
        <div class="alt-text position-absolute z-1 text-white">
          @if (
            heroData.backgroundImageDesktop !== "hero-the-benefit-of-knowing" &&
            heroData.backgroundImageDesktop !== "hero-make-a-plan" &&
            heroData.backgroundImageDesktop !== "hero-how-to-screen" &&
            heroData.backgroundImageDesktop !== "family-history"
          ) {
            <p
              class="mb-0"
              [innerHTML]="heroData.altText || 'Paid Sanofi spokesperson'"
            ></p>
          } @else if (heroData.altText) {
            <p
              class="mb-0"
              [innerHTML]="heroData.altText"
            ></p>
          }
        </div>
        <div
          class="photo-frame__bottom d-none d-md-block d-lg-none w-100 bg-white position-absolute z-1 bottom-0"
        ></div>
      </div>
      <div
        class="text-box z-1 bg-white text-dark d-flex flex-column"
        [class.justify-content-start]="!heroData.bodyText"
        [class.justify-content-lg-center]="!heroData.bodyText"
        [class.justify-content-center]="heroData.bodyText"
      >
        <h1 class="text-uppercase">
          <span [innerHTML]="heroData.titleText"></span>{{ " " }}
          <span
            class="text-primary fst-italic"
            [innerHTML]="heroData.titleColorText"
          ></span>
        </h1>
        <p
          class="mb-0"
          [ngClass]="heroData.bodyTextDesktopWidth"
          [innerHTML]="heroData.bodyText"
        ></p>
      </div>
    </div>
  </div>
} @placeholder {
  <div class="vw-100 vh-100"></div>
}
